import { FunctionComponent } from 'react'
import { Button } from '@matillion/component-library'
import { useTranslation } from 'react-i18next'

import { Header, HeaderTitle, HeaderWithCTA } from 'components/Header'

interface ListingHeaderProps {
  onAddOAuth: VoidFunction
  permission?: boolean
}

const ListingHeader: FunctionComponent<ListingHeaderProps> = ({
  onAddOAuth,
  permission = false
}) => {
  const { t } = useTranslation()

  return (
    <Header fullWidth centerAlign={false}>
      <HeaderWithCTA>
        <HeaderTitle
          data-testid="oauth-title"
          centerAlign={false}
          headerElement="h2"
          format="tm"
          withBottomSpace={false}
        >
          {t('secrets.oauthListing.title')}
        </HeaderTitle>

        {permission && (
          <Button
            text={t('secrets.oauthListing.buttonText')}
            onClick={onAddOAuth}
            data-testid="add-oauth-button"
            alt="positive"
          />
        )}
      </HeaderWithCTA>
    </Header>
  )
}

export default ListingHeader
